import React from 'react';
import ReactEmoji from 'react-emoji';
import Fade from '@material-ui/core/Fade';
import { makeStyles} from '@material-ui/core/styles';
import '../images/images.css';

const useStyles = makeStyles((theme) => ({
  messageBox: {
    background: '#03a9f4',
    borderRadius: '0.8em',
    padding: '0 20px',
    color: 'white',
    display: 'inline-block',
    maxWidth: '80%',
  },
  messageText: {
    width: '100%',
    letterSpacing: '0',
    float: 'left',
    fontSize: '1em',
    wordWrap: 'break-word',
    verticalAlign: 'middle',  
  },
  
  messageContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 5%',
    marginTop: '5px',
    marginBottom: '5px',
  },
  sentText: {
    display: 'flex',
    alignItems: 'center',
    color: '#282C2F',
    fontSize: '14px',
    fontWeight: '400',
    letterSpacing: '0.3px',
  },

  pl10: {
    paddingLeft: '10px',
  },
  
  pr10: {
    paddingRight: '10px',
  },

  justifyStart: {
    justifyContent: 'flex-start',
  },
  
  justifyEnd: {
    justifyContent: 'flex-end',
  },
  
  colorWhite: {
    color: 'white',
  },
  
  backgroundBlue: {
    background: '#00ddd5s',
  },
  
  backgroundLight: {
    background: '#282C2F',
  },
}));

export default function Message (props) {

  const classes = useStyles();
  let isSentByCurrentUser = false;

  if(props.message.user === props.name) {
    isSentByCurrentUser = true;
  }

    if(isSentByCurrentUser){
      return(
        <Fade in='true'>
          <div className={classes.messageContainer+ ' ' + classes.justifyEnd}>
            <p className={classes.sentText+ ' ' + classes.pr10}>{props.name}</p>
            <div className={classes.messageBox + ' ' + classes.backgroundBlue}>
              <p className={classes.messageText + ' ' + classes.colorWhite}>{ReactEmoji.emojify(props.message.text)}</p>
            </div>
          </div>
        </Fade>
      )
    }
    else{
      return(
        <Fade in='true'>
          <div className={classes.messageContainer+ ' ' + classes.justifyStart}>
            <div className={classes.messageBox+ ' ' + classes.backgroundLight}>
              <p className={classes.messageText+ ' ' + classes.colorWhite}>{ReactEmoji.emojify(props.message.text)}</p>
            </div>
            <p className={classes.sentText + ' ' + classes.pl10 }>{props.message.user}</p>
          </div>
        </Fade>
      )
    }
}